import type { RouteRecordRaw } from 'vue-router'

export const homeRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '智慧物流首页 - Walltech',
      requiresAuth: false
    }
  },
  // 租户登录（对应 home 落地页登录）
  {
    path: '/auth/tenant',
    name: 'TenantLogin',
    component: () => import('@/views/home/auth/index.vue'),
    meta: {
      title: '租户登录 - Walltech',
      requiresAuth: false
    }
  },
  {
    path: '/sso/auth/:provider/:type?',
    name: 'SsoAuth',
    component: () => import('@/views/home/auth/sso-auth.vue'),
    meta: {
      title: 'SSO授权',
      hidden: true
    }
  },
  // 404 页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/404.vue'),
    meta: {
      title: '页面未找到'
    }
  }
]
